import Collection from './collection.js';
import PayrollIntegration from 'newModels/payroll-integration.js';

export default class PayrollIntegrations extends Collection {
    url() {
        if (this.payroll) {
            return this.payroll.url() + '/integrations';
        }

        if (this.integration) {
            return this.integration.url() + '/payrollIntegrations';
        }

        return '/PayrollIntegrations';
    }

    initialize(models, {payroll = null, integration = null} = {}) {
        this.model = PayrollIntegration;
        super.initialize(...arguments);
        this.payroll = payroll;
        this.integration = integration;
        return this;
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/payroll-integrations.js